<style scoped>
.role-checkbox {
  padding-right: 8px;
}
td {
  padding: 4px;
  text-align: center;
}
table {
  width: 100%;
}
</style>

<template>
<mu-container>
  <mu-card>
    <mu-card-text>
      <mu-form :model="params">
        <mu-form-item :label="$t('pass.userId')">
          <mu-text-field v-model="params.user_id" />
        </mu-form-item>
        <mu-form-item :label="$t('pass.apiName')">
          <mu-text-field v-model="params.apiName" />
        </mu-form-item>
        <mu-date-input v-model="params.start" :label="$t('analytics.other.export.date.start')" type="dateTime"></mu-date-input>
        <mu-date-input v-model="params.end" :label="$t('analytics.other.export.date.end')" type="dateTime"></mu-date-input>
        <br />
        <mu-button @click="fetchPass" color="primary">{{$t('prompt.search')}}</mu-button>
      </mu-form>
      <br />
      <mu-data-table stripe :columns="columns" :data="pass" :no-data-text="$t('empty.noDataTitle')">
        <template slot="expand" slot-scope="prop">
          <div class="display-flex">
            <div>
              <h5>{{$t('pass.user')}}</h5>
              <pre>{{prop.row.user}}</pre>
            </div>
            <div>
              <h5>{{$t('pass.details')}}</h5>
              <pre>{{prop.row.details}}</pre>
          </div>
          </div>
        </template>
        <template slot-scope="scope">
          <td>{{timestampToString(scope.row.time)}}</td>
          <td><mu-icon :value="scope.row.check.roles ? 'done' : 'close'" /></td>
          <td><mu-icon :value="scope.row.check.enrollment ? 'done' : 'close'" /></td>
          <td><mu-icon :value="scope.row.check.management ? 'done' : 'close'" /></td>
        </template>
      </mu-data-table>
    </mu-card-text>
  </mu-card>

</mu-container>
</template>

<script>
// Library
import lastTimeAt from '@/utils/lastTimeAt.js'

import axios from "axios";

export default {
    name: 'PassPage',
    components: {
        
    },
    data() {
        return {
            // Object
            pass: [],
            params: {
              user_id: "",
              apiName: "",
              start: "",
              end: "",
            },
        }
    },
    computed: {
        // Store
        triggerRefresh() {
            return this.$store.getters.triggerRefresh;
        },
        isAdmin() {
            return this.$store.getters.isAdmin;
        },
        columns() {
          return [
            { title: this.$t('pass.time'), name: 'time' },
            { title: this.$t('pass.check.roles'), name: 'roles' },
            { title: this.$t('pass.check.enrollment'), name: 'enrollment' },
            { title: this.$t('pass.check.management'), name: 'management' },
          ];
        }
    },
    watch: {
    },
    created() {
        if(!this.isAdmin) {
            this.$router.push({
                name: 'Home'
            });
        } else {
            if(this.$route.query.hasOwnProperty('apiName')) {
                this.params.apiName = this.$route.query.apiName;
            }
        }
    },
    methods: {
        // Fetch
        fetchPass() {
            let esc = encodeURIComponent;
            let query = Object.keys(this.params).filter(i => this.params[i]).map(k => esc(k) + '=' + esc(this.parseParams(k, this.params[k]))).join('&');
            axios.get(this.$store.getters.urlApi + "pass?" + query, {
                headers: {
                  token: this.$store.state.auth.token
                }
              }
            ).then(response => {
                this.pass = response.data.data.passes
            });
        },
        timestampToString(time) {
          var datetime = new Date();
          datetime.setTime(time * 1000);
          var year = datetime.getFullYear();
          var month = datetime.getMonth() + 1;
          var date = datetime.getDate();
          var hour = datetime.getHours();
          var minute = datetime.getMinutes();
          var second = datetime.getSeconds();
          return year + "-" + this.pad(month, 2) + "-" + this.pad(date, 2) + " " + this.pad(hour, 2) + ":" + this.pad(minute, 2) + ":" + this.pad(second, 2);
        },
        pad(n, width, z) {
          z = z || '0';
          n = n + '';
          return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        },
        parseParams(key, value) {
          if(key === 'start' || key === 'end') {
            var d = new Date(value);
            return d.getTime() / 1000;
          } else {
            return value;
          }
        }
    }
}
</script>
